export enum FilterCategories {
  ProductType = 1,
  EnrollmentTerm = 2,
  CertificationMethod = 3,
  CertificationStatus = 4,
  Lenders = 5,
  DisbursementMethod = 6,
  DisbursementStatus = 7,
  ApplicationStatus = 8,
  ProcessorFilter = 9,
  StipulationStatus = 10,
}

export enum SearchTypes {
  NAME = 1,
  APPLICATION_ID = 2,
  SSN = 3,
  CLUID = 4,
  NAME_EXACT = 5,
  EMAIL = 6,
  PRIMARY_APPLICANT_EMAIL = 7,
  CO_APPLICANT_EMAIL = 8,
  PRIMARY_APPLICANT_NAME = 9,
  PRIMARY_APPLICANT_NAME_EXACT = 10,
  CO_APPLICANT_NAME = 11,
  CO_APPLICANT_NAME_EXACT = 12,
	GENERIC_TEXT_INPUT = 13
}

export enum Operators {
  EXACT_MATCH = 1,
  PARTIAL_MATCH = 2,
}